/**
 * 사용자 UI 환경설정 — backend /auth/preferences 와 1:1.
 */

import type { ApiResponse, UserPreferences } from './types';

const BASE = '/api';

export async function getPreferences(): Promise<UserPreferences> {
  const res = await fetch(`${BASE}/auth/preferences`, { credentials: 'include' });
  const json = (await res.json()) as ApiResponse<{ preferences: UserPreferences }>;
  if (!json.ok) throw new Error(json.error.message);
  return json.data.preferences;
}

export async function patchPreferences(patch: Partial<UserPreferences>): Promise<UserPreferences> {
  const res = await fetch(`${BASE}/auth/preferences`, {
    method: 'PATCH',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ preferences: patch }),
  });
  const json = (await res.json()) as ApiResponse<{ preferences: UserPreferences }>;
  if (!json.ok) throw new Error(json.error.message);
  return json.data.preferences;
}
